<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/crN863/images/cover.jpg?1684515193696" alt="This image is the cover for the book The Unlikely Hero, Verses of Vrelenden"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Unlikely Hero, Verses of Vrelenden
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>Verses of Vrelenden: Book One</i></b></p><p>Despite the suspicions Mother Dragon shared with Celestrian before her death, he may be the last surviving unicorn of Vrelenden—though most may simply think him some crazy person with a horn attached to his forehead. Nevertheless, Trian has nothing to hold on to but hope, and he’s about to hang that hope on an unlikely hero named Renwald Mallorian. Ren may have been born an accountant’s son, but he’s longed to be a professional hero for as long as he can remember, and he’s read every book on the subject he could get his hands on. When Trian arrives and hires him to find the last remaining unicorns, Ren jumps at the offer and their quest begins.</p> <p>But the evil Father Denkham is intent on obtaining the last unicorn and sets a deadly assassin on their trail. If that isn’t bad enough, they’ll face a Vampire, Dragon, bandits, and zombies. Their only hope now is for Ren to prove he’s the hero he always dreamed of becoming—but no book in the world could have prepared him for what’s in store.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Beau Schemery
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?df0dd41c